import moment from 'moment-timezone';
import getItemStyles from '../../../utils/item-styles';
import getOffsetTime from '../../../../../utils/getOffsetTime';
import timelineDisplayOrder from './timelineDisplayOrder';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments';

/**
 * Returns a formatted day off item for the one to two day posted schedule.
 * @param {*} resource
 * @param {*} dayType
 */
const generateOffTime = (resource, dayType) => {
  moment.tz.setDefault('UTC');
  const { rId } = resource;
  const { rdtId, dayTypeName } = dayType
  const { dorId, abbreviation, startTime, endTime, dayTypeComment, myDayTypeComment, isApproved } = dayType.dayOff;
  let hasComment = false;
  if ( ignoreDummyComments(dayTypeComment || myDayTypeComment) ) {
    hasComment = true;
  }
  const offtimeStyle = getItemStyles('offtime');
  const momentStartTime = moment.unix(startTime);
  const offsetTime = 0;//getOffsetTime(momentStartTime._d);
  const offsetStartTime = moment(momentStartTime).add(offsetTime, 'minutes');
  const offsetEndTime = moment.unix(endTime).add(offsetTime, 'minutes');
  const offTime = {
    id: rdtId,
    itemType: 'off-time',
    group: rId,
    dorId,
    title: dayTypeName,
    dayTypeName,
    abbreviation,
    start_time: offsetStartTime,
    end_time: offsetEndTime,
    dayTypeComment,
    myDayTypeComment,
    backgroundColor: dayType.dayOff.isApproved ? 'gray' : offtimeStyle.backgroundColor,
    borderStyle: offtimeStyle.borderStyle,
    borderColor: hasComment ? 'red' : offtimeStyle.borderColor,
    timelineDisplayOrder: timelineDisplayOrder.dayOff,
    dayRequestId: dayType.dayRequestId && dayType.dayRequestId !== '0' ? dayType.dayRequestId : null,
    isApproved
  };
  return offTime;
}

export default generateOffTime;



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/utils/generate-timeline/generateOffTime.js